import clsx from 'clsx';
import React from 'react';

import classes from './PetItem.module.scss';
import { PetAvatar } from 'components/Pet/Avatar/PetAvatar';
import { PetForm } from 'types/FormsInvitation';

interface PetItemProps {
    pet: PetForm;
    isSelected: boolean;
    onSelect: () => void;
}

export const PetItem: React.FC<PetItemProps> = props => {
    return (
        <div className={clsx(classes.root, { [classes.selected]: props.isSelected })}>
            <div className={classes.petIcon}>
                <PetAvatar
                    image={props.pet.imageUrl}
                    petType={props.pet.petType}
                    onClick={() => undefined}
                />
            </div>

            <div className={classes.petInfo}>
                <div className={classes.petName}>{props.pet.name}</div>
                <div className={classes.petBreed}>{props.pet.breed}</div>
                <div
                    className={clsx(classes.status, {
                        [classes.statusPending]: props.pet.formsStatus === 'Pending',
                        [classes.statusCompleted]: props.pet.formsStatus === 'Completed'
                    })}
                >
                    {props.pet.formsStatus}
                </div>
            </div>

            <button
                type="button"
                className={clsx(classes.selectButton, {
                    [classes.selectButtonActive]: props.isSelected
                })}
                onClick={props.onSelect}
            >
                {props.isSelected ? 'Selected' : 'Select'}
            </button>
        </div>
    );
};
